import { timestamp2Time } from './timeCalculate'

/**
 * @每个router会自动创建一个pageId[为了防止重复，并且方便管理，防止内存泄漏], 当结束时候，可以判断是否还有下一轮活动进行重新开启start
 * 调用方式 1. 开启。timerManager.start(Number(timestamp), (status, data) => {
                if (status === 1) {
                    this.$emit('success')
                } else {
                    this.nowTime = data
                }
            })
            2. 关闭。当页面关闭之后
            timerManager.end()
    当页面销毁的
 */
class TimerManager {
    static instance = null
    static pageId = null
    static getInstance () {
        TimerManager.pageId = new Date().getTime()
        if (!TimerManager.instance) {
            TimerManager.instance = new TimerManager()
        }
        return TimerManager.instance
    }

    static remoteInstance () {
        TimerManager.instance = null
    }

    constructor () {
        this.mapList = new Map()
    }

    start (...args) {
        if (typeof Number(args[0]) === 'number' && typeof args[1] === 'function') {
            if (Number(args[0]) <= 0)  return args[1](1, timestamp2Time(this.nowTimespace))
            this.put(...args)
        } else {
            throw Error(String('第一个参数为时间戳, 第二个参数为函数'))
        }
    }
    put (...args) {
        let key = TimerManager.pageId
        let target = this.mapList.get(key)
        if (target) {
            target.start(args[0])
        } else {
            let timer = new Timer(key, ...args)
            this.mapList.set(key, timer)
            return timer.start()
        }
    }

    end () {
        for (let item of this.mapList.entries()) {
            item[1].stop()
        }
        this.mapList.delete(this.pageId)
        TimerManager.remoteInstance()
    }
}

class Timer {
    constructor (pageId, ...args) {
        this.nowTimespace = args[0]
        this.callback = args[1]
        this.interval = null
        this.pageId = pageId
    }
    start (time = this.nowTimespace) {
        this.stop()
        this.interval = setInterval(() => {
            if (time >= 0) {
                this.callback(0, timestamp2Time(time))
            } else {
                this.stop()
                this.callback(1, timestamp2Time(time))
            }
            time -= 1
        }, 1000)
    }
    stop () {
        if (this.interval) clearInterval(this.interval)
        console.info('clearInterval', this.interval)
    }
}
export default TimerManager
